export enum ClientDocumentTypeEnum {
  Passport = 1,
  InternationalPassport,
  DrivingLicense,
}
